import deleteItemsStoreUpdate, {
    ItemContext,
} from 'owa-mail-actions/lib/triage/deleteItemsStoreUpdate';
import updateFolderCounts from 'owa-mail-actions/lib/updateFolderCounts';
import { orchestrator } from 'satcheljs';

export default orchestrator(deleteItemsStoreUpdate, actionMessage => {
    const itemContexts: ItemContext[] = actionMessage.itemContexts;
    let totalUnreadDeleted = 0;
    for (const itemContext of itemContexts) {
        if (!itemContext.isRead) {
            totalUnreadDeleted++;
        }
    }

    updateFolderCounts(
        -1 * totalUnreadDeleted /* unreadCount */,
        -1 * itemContexts.length /* totalCount */,
        actionMessage.parentFolderId /* folderId */,
        true /* isDeltaChange */
    );
});
